import { createI18n } from 'vue-i18n';
import translations from '@/locales';

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: translations
});

export default i18n;


